export const PURCHASED_DELINQUENT_STATUS = "Delinquent";

export const PURCHASED_DELINQUENCY_TAG_STYLE = {
  backgroundColor: "#ffad17"
};

export type PurchasedDelinquencyStateInfo = {
  loanStatus?: string | null;
  delinquencyStatus?: string | null;
  delinquencyStatusOts?: string | null;
};

/**
 * Returns true when the purchased-loan status is delinquent.
 */
export function isDelinquentPurchasedLoanStatus(
  loanStatus?: string | null
): boolean {
  return loanStatus === PURCHASED_DELINQUENT_STATUS;
}

/**
 * Returns MBA/OTS delinquency values for header display. Non-delinquent loans
 * get nulls so the tags are not shown.
 */
export function getPurchasedDelinquencyDisplayFields(
  loanStatus?: string | null,
  delinquencyStatus?: string | null,
  delinquencyStatusOts?: string | null
): {
  delinquencyStatus: string | null;
  delinquencyStatusOts: string | null;
} {
  if (!isDelinquentPurchasedLoanStatus(loanStatus)) {
    return { delinquencyStatus: null, delinquencyStatusOts: null };
  }
  return {
    delinquencyStatus: delinquencyStatus ?? null,
    delinquencyStatusOts: delinquencyStatusOts ?? null
  };
}

/**
 * Builds MBA/OTS delinquency header tags for delinquent purchased loans only.
 */
export function buildPurchasedDelinquencyTags(
  purchasedStateInfo?: PurchasedDelinquencyStateInfo | null
): Array<{ label: string; style: { backgroundColor: string } }> {
  if (
    !purchasedStateInfo ||
    !isDelinquentPurchasedLoanStatus(purchasedStateInfo.loanStatus)
  ) {
    return [];
  }
  const tags: Array<{ label: string; style: { backgroundColor: string } }> = [];
  if (purchasedStateInfo.delinquencyStatus) {
    tags.push({
      label: `MBA: ${purchasedStateInfo.delinquencyStatus}`,
      style: PURCHASED_DELINQUENCY_TAG_STYLE
    });
  }
  if (purchasedStateInfo.delinquencyStatusOts) {
    tags.push({
      label: `OTS: ${purchasedStateInfo.delinquencyStatusOts}`,
      style: PURCHASED_DELINQUENCY_TAG_STYLE
    });
  }
  return tags;
}
